/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendAdvancedProductDto } from '../../models/backend-advanced-product-dto';
import { BackendPatchedAdvancedProductRequestDto } from '../../models/backend-patched-advanced-product-request-dto';

export interface SalesAdvancedProductsPartialUpdate$XWwwFormUrlencoded$Params {
  id: number;
  body?: BackendPatchedAdvancedProductRequestDto;
}

export function salesAdvancedProductsPartialUpdate$XWwwFormUrlencoded(
  http: HttpClient,
  rootUrl: string,
  params: SalesAdvancedProductsPartialUpdate$XWwwFormUrlencoded$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendAdvancedProductDto>> {
  const rb = new RequestBuilder(rootUrl, salesAdvancedProductsPartialUpdate$XWwwFormUrlencoded.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/x-www-form-urlencoded');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendAdvancedProductDto>;
    }),
  );
}

salesAdvancedProductsPartialUpdate$XWwwFormUrlencoded.PATH = '/api/sales/advanced-products/{id}/';
